module.exports = {
  WEB: 1,
  FILE_IMPORT: 2,
  API: 3,
};
